import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';

type SetQueryType =
  | ((key: string, value: string) => void)
  | ((entries: Record<string, string>) => void);

export default function useQuery(): [
  URLSearchParams,
  (key: string | Record<string, string>, value?: string) => void,
] {
  const history = useHistory();
  const { pathname, search } = useLocation();
  const query = React.useMemo(() => new URLSearchParams(search), [search]);

  const setQuery = (key: string | Record<string, string>, value?: string) => {
    const nextQuery = new URLSearchParams(query.toString());

    if (typeof key === 'string') {
      if (value === '') {
        nextQuery.delete(key);
      } else {
        nextQuery.set(key, value!);
      }
    } else {
      // key is an object with multiple key-value pairs
      for (const [k, v] of Object.entries(key)) {
        if (v === '') {
          nextQuery.delete(k);
        } else {
          nextQuery.set(k, v);
        }
      }
    }

    const nextSearch = nextQuery.toString();
    const currentSearch = query.toString();

    if (nextSearch === currentSearch) {
      return;
    }

    history.push(`${pathname}?${nextSearch}`);
  };

  return [query, setQuery];
}
